import * as React from 'react'
import { AnimatePresence } from 'framer-motion'

interface ActionPopoverBodyProps {
  children: React.ReactNode
  mode?: 'sync' | 'popLayout' | 'wait'
}

function ActionPopoverBody({ children, mode = 'popLayout' }: ActionPopoverBodyProps) {
  return <AnimatePresence mode={mode}>{children}</AnimatePresence>
}

export { ActionPopoverBody }
